import type { FormEvent } from 'react';
import { Button } from '@shared/ui/Button';
import { ACCOUNT_TYPE_LABELS } from '../ceoFormat';
import {
  FormActions,
  FormBox,
  FormGrid,
  FormHint,
  FormTitle,
  Input,
  Select,
} from './styles';

interface AccountRequisitesModalProps {
  accountNumber: string;
  reqName: string;
  setReqName: (v: string) => void;
  reqInn: string;
  setReqInn: (v: string) => void;
  reqKpp: string;
  setReqKpp: (v: string) => void;
  reqBik: string;
  setReqBik: (v: string) => void;
  reqCorr: string;
  setReqCorr: (v: string) => void;
  reqType: string;
  setReqType: (v: string) => void;
  reqPurpose: string;
  setReqPurpose: (v: string) => void;
  isSaving: boolean;
  onSubmit: (e: FormEvent) => void;
  onClose: () => void;
}

export function AccountRequisitesModal({
  accountNumber,
  reqName,
  setReqName,
  reqInn,
  setReqInn,
  reqKpp,
  setReqKpp,
  reqBik,
  setReqBik,
  reqCorr,
  setReqCorr,
  reqType,
  setReqType,
  reqPurpose,
  setReqPurpose,
  isSaving,
  onSubmit,
  onClose,
}: AccountRequisitesModalProps) {
  return (
    <FormBox as="form" onSubmit={onSubmit}>
      <FormTitle>Реквизиты плательщика: счёт {accountNumber}</FormTitle>
      <FormHint>
        Попадают в платёжки файла для банка. Остатки и подключение счёта не меняются. У ИП КПП
        нет.
      </FormHint>
      <FormGrid>
        <Input
          placeholder="Владелец счёта (юрлицо)"
          value={reqName}
          onChange={(e) => setReqName(e.target.value)}
          required
        />
        <Input
          placeholder="ИНН владельца (10 или 12 цифр)"
          value={reqInn}
          onChange={(e) => setReqInn(e.target.value)}
          inputMode="numeric"
          required
        />
        <Input
          placeholder="КПП владельца (9 цифр)"
          value={reqKpp}
          onChange={(e) => setReqKpp(e.target.value)}
          inputMode="numeric"
        />
        <Input
          placeholder="БИК банка (9 цифр)"
          value={reqBik}
          onChange={(e) => setReqBik(e.target.value)}
          inputMode="numeric"
          required
        />
        <Input
          placeholder="Корр. счёт банка (20 цифр)"
          value={reqCorr}
          onChange={(e) => setReqCorr(e.target.value)}
          inputMode="numeric"
          required
        />
        <Select value={reqType} onChange={(e) => setReqType(e.target.value)}>
          {Object.entries(ACCOUNT_TYPE_LABELS).map(([value, label]) => (
            <option key={value} value={value}>
              {label}
            </option>
          ))}
        </Select>
        <Input
          placeholder="Назначение счёта"
          value={reqPurpose}
          onChange={(e) => setReqPurpose(e.target.value)}
        />
      </FormGrid>
      <FormActions>
        <Button $size="sm" type="submit" disabled={isSaving}>
          {isSaving ? 'Сохранение…' : 'Сохранить реквизиты'}
        </Button>
        <Button
          $size="sm"
          $variant="ghost"
          type="button"
          onClick={onClose}
        >
          Отмена
        </Button>
      </FormActions>
    </FormBox>
  );
}
